export default __webpack_public_path__ + "static/media/logo1.66759b84.png";